import script from "./disp-menu-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./disp-menu-button.vue?vue&type=script&setup=true&lang=ts"

import "./disp-menu-button.vue?vue&type=style&index=0&id=9f003b30&lang=scss"

const __exports__ = script;

export default __exports__